// @flow

import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import styled from 'styled-components';

import Helmet from 'react-helmet';

import type { IntlShape } from 'react-intl';
import type {
  Category as CategoryType,
} from '../../types/model';
import { selectors as FromCategories } from '../../redux/modules/categories';
import { selectors as FromProducts } from '../../redux/modules/products';
import { selectors as FromArticles } from '../../redux/modules/articles';

import CategoryNav from '../CategoryNav/CategoryNav';
import Coin from './Coin';

const Root = styled.div`
  flex: 1;

  display: flex;
  justify-content: space-between;

  padding: 0 90px;
  min-height: 180px;
`;

const ContentTypeWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  contentType: ?string,
  category: ?CategoryType,
  parentCategory: ?CategoryType,
  intl: IntlShape,
}

function Directions({ contentType, category, parentCategory, intl }: Props) {
  return (
    <Root>
      {contentType && (
        <Helmet>
          <title>{category ? category.title : intl.formatMessage({ id: `title.${contentType}` })}</title>
        </Helmet>
      )}

      <ContentTypeWrap>
        <Coin
          contentType="doctor"
          selected={category && category.contentType === 'doctor'}
          categoryId={category && category.id}
          parentCategoryId={parentCategory && parentCategory.id}
        />
      </ContentTypeWrap>
      {contentType && (
        <CategoryNav
          contentType={contentType}
          selectedId={category && category.id}
        />
      )}
      <ContentTypeWrap>
        <Coin
          contentType="patient"
          selected={category && category.contentType === 'patient'}
          categoryId={category && category.id}
          parentCategoryId={parentCategory && parentCategory.id}
        />
      </ContentTypeWrap>
    </Root>
  );
}

function mapStateToProps(state, props) {
  const categoryId = parseInt(props.match.params.categoryId, 10);

  const article = FromArticles.getById(state.articles, parseInt(props.match.params.articleId, 10));
  const product = FromProducts.getById(state.products, parseInt(props.match.params.productId, 10));
  const category = FromCategories.getById(state.categories, categoryId) || (product && FromCategories.getById(state.categories, product.categoryId)) || (article && FromCategories.getById(state.categories, article.categoryId));
  const parentCategory = category
    ? FromCategories.getById(state.categories, category.parentId)
    : null;

  return ({
    category,
    parentCategory
  })
}

export default compose(
  injectIntl,
  connect(mapStateToProps)
)(Directions);



// WEBPACK FOOTER //
// ./src/components/Directions/Directions.js